//////////////////////////////////////////
//src/assets/scripts/common.js
//////////////////////////////////////////
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Swiper from 'swiper';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import Lenis from 'lenis'

gsap.registerPlugin(ScrollTrigger);


export default class CommonJS {
    constructor() {
    }

    init() {
        this._headBtn();
        // this._headScroll();
        // this._scrollSmoose();
        // this._grovalPcNav();
    }


    
    _headBtn() {
        const navToggle = document.querySelector('.nav-toggle');
        const header = document.querySelector('#header');
        const nav = document.querySelector('.nav_area');

        navToggle.addEventListener('click', function () {
            header.classList.toggle('open');
        });
        nav.addEventListener('click', function () {
            header.classList.remove('open');
        });
    }

    _headScroll() {
        const navToggle = document.querySelector('.nav-toggle');
        const header = document.querySelector('#header');
        const nav = document.querySelector('.nav_area');

        navToggle.addEventListener('click', function () {
            header.classList.toggle('open');
        });
        nav.addEventListener('click', function () {
            header.classList.remove('open');
        });
    }

    _scrollSmoose() {
        const links = document.querySelectorAll('a[href^="#"]');
        if (!links.length) return;

        const header = document.querySelector('.Header');
        const getHeaderH = () => (header ? header.getBoundingClientRect().height : 0);

        links.forEach((a) => {
            a.addEventListener(
                "click",
                (e) => {
                    const href = a.getAttribute("href");
                    if (!href || href[0] !== "#") return;

                    e.preventDefault();

                    // PAGE TOP（href="#" or "#top"）は先頭へ
                    if (href === "#" || href === "#top") {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        return;
                    }

                    const target = document.querySelector(href);
                    if (!target) return;

                    const customOffset = Number(a.dataset.scrollOffset || 0) || 0;

                    const y =
                        window.pageYOffset +
                        target.getBoundingClientRect().top -
                        getHeaderH() -
                        customOffset;

                    window.scrollTo({ top: y, behavior: "smooth" });
                },
                { passive: false }
            );
        });
    }

 

    _grovalPcNav() {
        const header = document.querySelector("#header");
        const nav = document.querySelector(".nav_area");
        if (!header || !nav) return;

        const links = Array.from(nav.querySelectorAll("a[href^='#']"));
        if (!links.length) return;

        const items = links
            .map((a) => {
                const id = a.getAttribute("href");
                const sec = id ? document.querySelector(id) : null;
                const li = a.closest("li");
                if (!sec || !li) return null;
                return { li, sec, id, a };
            })
            .filter(Boolean);

        if (!items.length) return;

        const mvArea = document.querySelector("#Mv_area");
        const areaB = document.querySelector(".areaB");

        const clearCurrent = () => items.forEach(({ li }) => li.classList.remove("current"));
        const setCurrentById = (id) =>
            items.forEach(({ li, id: _id }) => li.classList.toggle("current", _id === id));

        const pickSectionId = () => {
            const y = window.innerHeight * 0.35;
            for (const { sec, id } of items) {
                const r = sec.getBoundingClientRect();
                if (r.top <= y && r.bottom > y) return id;
            }
            return null;
        };

        const inMvNow = () => {
            if (!mvArea) return false;
            const r = mvArea.getBoundingClientRect();
            return r.top <= 0 && r.bottom > 0;
        };

        // const inAreaBNow = () => {
        //     if (!areaB) return false;
        //     const r = areaB.getBoundingClientRect();
        //     const enterLine = window.innerHeight * 0.8;
        //     return r.top <= enterLine && r.bottom > 0;
        // };

        const inAreaBNow = () => {
            if (!areaB) return false;

            const r = areaB.getBoundingClientRect();
            const enterLine = window.innerHeight * 0.8;

            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const winH = window.innerHeight;
            const docH = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight
            );

            const isBottom = scrollTop + winH >= docH - 2;

            return (r.top <= enterLine && r.bottom > 0) || isBottom;
        };


        const applyHeaderMode = (mode) => {
            header.classList.toggle("styleA", mode === "A");
            header.classList.toggle("styleB", mode === "B");
        };

        const sync = () => {
            if (inMvNow()) {
                applyHeaderMode("A");
                clearCurrent();
                return;
            }
            if (inAreaBNow()) {
                applyHeaderMode("B");
                clearCurrent();
                return;
            }

            applyHeaderMode(null);

            const id = pickSectionId();
            if (id) setCurrentById(id);
            else clearCurrent();
        };

        ScrollTrigger.create({
            trigger: document.body,
            start: "top top",
            end: "bottom bottom",
            onUpdate: sync,
            onRefresh: sync,
        });

        // Howto に飛ぶ時は毎回1枚目へ戻す
        items.forEach(({ a, id }) => {
            if (id !== "#Howto_area" && id !== "#Howto_area_Link") return;

            a.addEventListener("click", () => {
                if (this.howtoSwiper) this.howtoSwiper.slideTo(0, 0);
                if (this.howtoTxtSwiper) this.howtoTxtSwiper.slideTo(0, 0);
            });
        });

        sync();
        requestAnimationFrame(() => ScrollTrigger.refresh());
    }

}
